export const CURRENT_INTERVENANT_KEY: string = 'current_intervenant';

export interface Privileges {
  isCourtManager: boolean;
  isOpeningManager: boolean;
}

export interface CurrentLawyer {
  given_name: string;
  sagis_code: string;
  preferred_username: string;
  sub: string;
  family_name: string;
  name: string;
  email: string;
  sagis_doctor_code: string;
  roles: string[];
}

const get = (): CurrentLawyer => {
  try {
    return JSON.parse(
      `${window.localStorage.getItem(CURRENT_INTERVENANT_KEY)}`,
    );
  } catch (error) {
    return {} as CurrentLawyer;
  }
};

const set = (currentLawyer: CurrentLawyer) =>
  window.localStorage.setItem(
    CURRENT_INTERVENANT_KEY,
    JSON.stringify(currentLawyer),
  );

const clear = () => window.localStorage.removeItem(CURRENT_INTERVENANT_KEY);

const currentIntervenantStorage = {
  get,
  set,
  clear,
};

export default currentIntervenantStorage;
